import { IJxtPictoGroup } from '../types';

export const JxtBookingPicto = ({ p }: IJxtPictoGroup) => {
  return <image width={p.size} height={p.size} href={p.url} x={p.x} y={p.y} />;
};
